import {
  CheckListType,
  CompanyId,
} from "features/CenterContent/RoleContent/VehicleChecklist/utils";
import { dateTimeSchemaResponse } from "shared/form/dateTimeSchema";
import { z } from "zod";

const FillOutBaseSchema = z.object({
  fillOutId: z.string(),
  executedAt: dateTimeSchemaResponse,
  companyId: z.custom<CompanyId>(),
  vehicleType: z.string(),
  checklistType: z.custom<CheckListType>(),
  rollingStock: z.string(),
  rollingStockType: z.string(),
  executor: z.string(),
  executorName: z.string().nullable(),
  changedBy: z.string(),
  changedByName: z.string(),
  changedAt: z.string(),
  comment: z.string().nullable().optional(),
});

const HistoryVersionSchema = FillOutBaseSchema.extend({
  history: z.null().optional(),
});

export type HistoryFillOut = z.infer<typeof HistoryVersionSchema>;

const HistorySchema = z.record(z.string(), HistoryVersionSchema);

const FillOutSchema = FillOutBaseSchema.extend({
  history: HistorySchema.optional(),
});

export type FillOut = z.infer<typeof FillOutSchema>;

export const FillOutsSchema = z.object({
  fillOuts: z.array(FillOutSchema),
});

export type FillOuts = z.infer<typeof FillOutsSchema>;
